import { setRangeMax } from './helpers';

export const setPriceMax = setRangeMax('price');
